import React, { useEffect, useRef, useState } from 'react';
import { listMediaFolders, MediaFolder } from '../../../../api/media';
import '../../../../assets/styles/media-manager.scss';
import { useNavigate } from 'react-router-dom';
import { MEDIA_BASE } from '../../../../api/config';

/** cover_url może być absolutny albo względny względem /media */
function resolveCoverUrl(src?: string | null): string | undefined {
  if (!src) return undefined;
  if (/^https?:\/\//i.test(src)) return src;
  const clean = src.startsWith('/') ? src : `/${src}`;
  return `${MEDIA_BASE}${clean}`;
}

export default function Media() {
  const navigate = useNavigate();

  const [folders, setFolders] = useState<MediaFolder[]>([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState('');
  const [showEmpty, setShowEmpty] = useState(false); // ⟵ NOWE: Pokaż puste

  // Guard na StrictMode (pierwsze wykonanie)
  const initializedRef = useRef(false);
  // Debounce timer
  const timerRef = useRef<number | null>(null);

  const loadFolders = async (query: string, includeEmpty: boolean) => {
    setLoading(true);
    try {
      const res = await listMediaFolders({
        q: query || undefined,
        includeEmpty,            // ⟵ zależne od toggle
        limit: 1000,
        offset: 0,
      });
      setFolders(res.items || []);
    } finally {
      setLoading(false);
    }
  };

  // Jeden efekt: mount + zmiany q/showEmpty (z debounce). Guard eliminuje duplikat z StrictMode.
  useEffect(() => {
    const delay = initializedRef.current ? 250 : 0;

    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      if (!initializedRef.current) {
        initializedRef.current = true;
      }
      loadFolders(q, showEmpty);
    }, delay) as unknown as number;

    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [q, showEmpty]);

  return (
    <div className="mm-box">
      <div className="mm-header">
        <h2>Media</h2>
        <div className="mm-actions">
          <input
            className="mm-search"
            placeholder="Szukaj treści (ID lub tytuł)…"
            value={q}
            onChange={e => setQ(e.target.value)}
          />
          <button
            className={showEmpty ? 'btn' : 'btn ghost'}
            onClick={() => setShowEmpty(v => !v)}
            title={showEmpty ? 'Ukryj foldery bez plików' : 'Pokaż foldery bez plików'}
          >
            {showEmpty ? 'Ukryj puste' : 'Pokaż puste'}
          </button>
        </div>
      </div>

      <div className="mm-folders-grid">
        {loading && <div className="mm-loading">Ładowanie…</div>}
        {!loading && !folders.length && <div className="mm-empty">Brak wyników</div>}

        {!loading && folders.map(f => (
          <button
            key={f.folder_id}
            className="mm-folder-card"
            onClick={() => navigate(`/admin/media/${f.folder_id}`, { state: { folder: f } })}
            title={`${f.folder_id}. ${f.folder_title}`}
          >
            <div className="mm-cover">
              {f.cover_url
                ? <img src={resolveCoverUrl(f.cover_url)} alt="" />
                : <div className="mm-nocover">—</div>}
            </div>
            <div className="mm-folder-meta">
              <div className="mm-folder-title">{f.folder_id}. {f.folder_title}</div>
              <div className="mm-folder-sub">Plików: <strong>{f.assets_count ?? 0}</strong></div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
